import "./App.css";
import Header from "./Header/Header";
import Content from "./Content/Content";

function App() {
  return (
    <div>
      <Header />
      <Content />
    </div>
  );
}

export default App;
